import Alert from "../../components/alert";
import Text from "../../components/input/text";
import Button from "../../components/button";
import {useEffect, useRef, useState} from "react";
import UseGetFormData from "../../hooks/UseGetFormData";
import {UsePost} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";

export const SendersForm = ({domain, sender, onUpsert}) => {
    const formRef = useRef()
    const [errors, setErrors] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')


    const handleSubmit = async (ev) => {
        ev.preventDefault();
        const FormData = UseGetFormData(formRef)

        setIsLoading(true)

        const payload = {
            name: FormData.get('name'),
            id_domain: domain?._id?.$oid,
            email: `${FormData.get('email')}@${domain.email_subdomain}.${domain?.name}`,
        }

        const response = await UsePost(
            `/senders/upsert/${sender ? sender?._id?.$oid : ''}`,
            {data: payload}
        )

        if (response.code >= 200 && response.code <= 299) {
            const action = sender ? 'updated' : 'created'
            UseMessage('success', `Sender has been successfully ${action}`)

            onUpsert({
                ...payload, ...{_id: {$oid: response._id}}
            })

            setErrors(undefined)
            setName('')
            setEmail('')

        } else {
            setErrors(response.errors)
        }

        setIsLoading(false)
    }

    useEffect(() => {
        if(sender) {
            setName(sender.name)
            setEmail(sender.email)
        }
    }, [sender]);


    return (
        <form ref={formRef} autoComplete="off" onSubmit={handleSubmit}>

            <Alert
                icon="info"
                docsPath="/docs/enterprises/domains"
                message={`From this section you can create new senders associated to the ${domain?.name} domain`}
            />

            <Text
                required
                size="sm"
                name="name"
                value={name}
                label="Sender name"
                isReady={!isLoading}
                error={errors?.name}
                placeholder="Company Name"
                onChange={ev => setName(ev.target.value)}
            />

            <Text
                required
                size="sm"
                name="email"
                value={email}
                label="Sender email"
                isReady={!isLoading}
                error={errors?.email}
                placeholder="Company Email"
                onChange={ev => setEmail(ev.target.value)}
                suffix={domain && `@${domain.email_subdomain}.${domain?.name}`}
            />

            <Button
                size="sm"
                icon="check"
                color="primary"
                isReady={!isLoading}
                className="mt-3 me-2"
                label={sender ? 'Update' : 'Create'}
            />
        </form>
    )
}